import { KeyValue } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ComplianceSettingForm } from 'src/app/classes/form-groups/compliance-setting-form';

@Component({
  selector: 'app-compliance-owner-background-checks',
  templateUrl: './compliance-owner-background-checks.component.html',
  styleUrls: ['./compliance-owner-background-checks.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ComplianceOwnerBackgroundChecksComponent {
  constructor() {
    this.ownerLiensMap.set('Not Required', null);
    this.ownerLiensMap.set('0 - $5,000', 5000);

    const increment = 10000;
    const maxValue = 1000000;

    for (let i = increment; i <= maxValue; i += increment) {
      const key = `< $${i.toLocaleString()}`;
      this.ownerLiensMap.set(key, i);
    }
  }

  @Input() complianceSettingForms?: ComplianceSettingForm[];

  collapseOwnersBackGroundChecks: boolean = true;

  rowHeaders: string[] = [
    '',
    'Corporation In Good Standing',
    'Corporate Identity Check',
    'Corporate Watchlist',
    'Corporate Bankruptcy Search',
    'Corporate Liens & Judgements',
    'W9 Check'
  ];

  ownerIdentityMap: Map<string, number | null> = new Map([
    ['Not Required', null],
    ['0', 0],
    ['10', 10],
    ['20', 20],
    ['30', 30],
    ['40', 40],
    ['50', 50]
  ]);

  ownerWatchlistMap: Map<string, number | null> = new Map([
    ['Not Required', null],
    ['No Watchlists', 0],
    ['1 Watchlist', 1],
    ['Multiple Watchlists', 2]
  ]);

  ownerBankruptcySearchMap: Map<string, number | null> = new Map([
    ['Not Required', null],
    ['Not Allowed', 0],
    ['1 Year', 1],
    ['2 Years', 2],
    ['3 Years', 3],
    ['4 Years', 4],
    ['5 Years', 5],
    ['6 Years', 6],
    ['7 Years', 7]
  ]);

  ownerFelonySearchMap: Map<string, number | null> = new Map([
    ['Not Required', null],
    ['No Felonies', 0],
    ['1 Year', 1],
    ['2 Years', 2],
    ['3 Years', 3],
    ['4 Years', 4],
    ['5 Years', 5],
    ['6 Years', 6],
    ['7 Years', 7],
    ['8 Years', 8],
    ['9 Years', 9],
    ['10 Years', 10]
  ]);

  ownerMisdemeanorSearchMap: Map<string, number | null> = new Map([
    ['Not Required', null],
    ['No Misdemeanors', 0],
    ['1 Year', 1],
    ['2 Years', 2],
    ['3 Years', 3],
    ['4 Years', 4],
    ['5 Years', 5],
    ['6 Years', 6],
    ['7 Years', 7],
    ['8 Years', 8],
    ['9 Years', 9],
    ['10 Years', 10]
  ]);

  ownerSexOffenderMap: Map<string, boolean | null> = new Map([
    ['Not Required', null],
    ['Allowed', true],
    ['Not Allowed', false]
  ]);

  ownerLiensMap: Map<string, number | null> = new Map();

  keyValuePairDefaultOrder(
    a: KeyValue<any, any>,
    b: KeyValue<any, any>
  ): number {
    return 0;
  }
}
